import { isAndroid, isIOS } from 'react-device-detect'

import { appStoreLink, googlePlayLink } from 'config/appLinks'

export const getDeviceLink = () => {
  if (isIOS) {
    return appStoreLink
  } else if (isAndroid) {
    return googlePlayLink
  } else {
    return ''
  }
}

export default {
  getDeviceLink
}



// WEBPACK FOOTER //
// ./src/services/downloadApp.ts